import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=489f887c&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=489f887c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f887c",
  null
  
)

export default component.exports